import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=4eade98c&scoped=true"
import script from "./SidebarLayout.vue?vue&type=script&lang=ts"
export * from "./SidebarLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eade98c",
  null
  
)

export default component.exports